import gql from 'graphql-tag';
import * as Urql from 'urql';
/** Methods to use when ordering `EventCategory`. */
export var EventCategoriesOrderBy;
(function (EventCategoriesOrderBy) {
    EventCategoriesOrderBy["CreatedByAsc"] = "CREATED_BY_ASC";
    EventCategoriesOrderBy["CreatedByDesc"] = "CREATED_BY_DESC";
    EventCategoriesOrderBy["IdAsc"] = "ID_ASC";
    EventCategoriesOrderBy["IdDesc"] = "ID_DESC";
    EventCategoriesOrderBy["NameAsc"] = "NAME_ASC";
    EventCategoriesOrderBy["NameDesc"] = "NAME_DESC";
    EventCategoriesOrderBy["Natural"] = "NATURAL";
    EventCategoriesOrderBy["OwnerOrganizationIdAsc"] = "OWNER_ORGANIZATION_ID_ASC";
    EventCategoriesOrderBy["OwnerOrganizationIdDesc"] = "OWNER_ORGANIZATION_ID_DESC";
    EventCategoriesOrderBy["PrimaryKeyAsc"] = "PRIMARY_KEY_ASC";
    EventCategoriesOrderBy["PrimaryKeyDesc"] = "PRIMARY_KEY_DESC";
    EventCategoriesOrderBy["UpdatedByAsc"] = "UPDATED_BY_ASC";
    EventCategoriesOrderBy["UpdatedByDesc"] = "UPDATED_BY_DESC";
})(EventCategoriesOrderBy || (EventCategoriesOrderBy = {}));
/** Methods to use when ordering `EventQuestion`. */
export var EventQuestionsOrderBy;
(function (EventQuestionsOrderBy) {
    EventQuestionsOrderBy["CreatedByAsc"] = "CREATED_BY_ASC";
    EventQuestionsOrderBy["CreatedByDesc"] = "CREATED_BY_DESC";
    EventQuestionsOrderBy["EventIdAsc"] = "EVENT_ID_ASC";
    EventQuestionsOrderBy["EventIdDesc"] = "EVENT_ID_DESC";
    EventQuestionsOrderBy["IdAsc"] = "ID_ASC";
    EventQuestionsOrderBy["IdDesc"] = "ID_DESC";
    EventQuestionsOrderBy["Natural"] = "NATURAL";
    EventQuestionsOrderBy["PositionAsc"] = "POSITION_ASC";
    EventQuestionsOrderBy["PositionDesc"] = "POSITION_DESC";
    EventQuestionsOrderBy["PrimaryKeyAsc"] = "PRIMARY_KEY_ASC";
    EventQuestionsOrderBy["PrimaryKeyDesc"] = "PRIMARY_KEY_DESC";
    EventQuestionsOrderBy["UpdatedByAsc"] = "UPDATED_BY_ASC";
    EventQuestionsOrderBy["UpdatedByDesc"] = "UPDATED_BY_DESC";
})(EventQuestionsOrderBy || (EventQuestionsOrderBy = {}));
/** Methods to use when ordering `Event`. */
export var EventsOrderBy;
(function (EventsOrderBy) {
    EventsOrderBy["CategoryIdAsc"] = "CATEGORY_ID_ASC";
    EventsOrderBy["CategoryIdDesc"] = "CATEGORY_ID_DESC";
    EventsOrderBy["CreatedByAsc"] = "CREATED_BY_ASC";
    EventsOrderBy["CreatedByDesc"] = "CREATED_BY_DESC";
    EventsOrderBy["EventEndTimeAsc"] = "EVENT_END_TIME_ASC";
    EventsOrderBy["EventEndTimeDesc"] = "EVENT_END_TIME_DESC";
    EventsOrderBy["EventStartTimeAsc"] = "EVENT_START_TIME_ASC";
    EventsOrderBy["EventStartTimeDesc"] = "EVENT_START_TIME_DESC";
    EventsOrderBy["IdAsc"] = "ID_ASC";
    EventsOrderBy["IdDesc"] = "ID_DESC";
    EventsOrderBy["IsDraftAsc"] = "IS_DRAFT_ASC";
    EventsOrderBy["IsDraftDesc"] = "IS_DRAFT_DESC";
    EventsOrderBy["IsHighlightedAsc"] = "IS_HIGHLIGHTED_ASC";
    EventsOrderBy["IsHighlightedDesc"] = "IS_HIGHLIGHTED_DESC";
    EventsOrderBy["NameAsc"] = "NAME_ASC";
    EventsOrderBy["NameDesc"] = "NAME_DESC";
    EventsOrderBy["Natural"] = "NATURAL";
    EventsOrderBy["OwnerOrganizationIdAsc"] = "OWNER_ORGANIZATION_ID_ASC";
    EventsOrderBy["OwnerOrganizationIdDesc"] = "OWNER_ORGANIZATION_ID_DESC";
    EventsOrderBy["PrimaryKeyAsc"] = "PRIMARY_KEY_ASC";
    EventsOrderBy["PrimaryKeyDesc"] = "PRIMARY_KEY_DESC";
    EventsOrderBy["RegistrationEndTimeAsc"] = "REGISTRATION_END_TIME_ASC";
    EventsOrderBy["RegistrationEndTimeDesc"] = "REGISTRATION_END_TIME_DESC";
    EventsOrderBy["RegistrationStartTimeAsc"] = "REGISTRATION_START_TIME_ASC";
    EventsOrderBy["RegistrationStartTimeDesc"] = "REGISTRATION_START_TIME_DESC";
    EventsOrderBy["SlugAsc"] = "SLUG_ASC";
    EventsOrderBy["SlugDesc"] = "SLUG_DESC";
    EventsOrderBy["UpdatedByAsc"] = "UPDATED_BY_ASC";
    EventsOrderBy["UpdatedByDesc"] = "UPDATED_BY_DESC";
})(EventsOrderBy || (EventsOrderBy = {}));
/** Methods to use when ordering `OrganizationMembership`. */
export var OrganizationMembershipsOrderBy;
(function (OrganizationMembershipsOrderBy) {
    OrganizationMembershipsOrderBy["IdAsc"] = "ID_ASC";
    OrganizationMembershipsOrderBy["IdDesc"] = "ID_DESC";
    OrganizationMembershipsOrderBy["MemberNameAsc"] = "MEMBER_NAME_ASC";
    OrganizationMembershipsOrderBy["MemberNameDesc"] = "MEMBER_NAME_DESC";
    OrganizationMembershipsOrderBy["Natural"] = "NATURAL";
    OrganizationMembershipsOrderBy["OrganizationIdAsc"] = "ORGANIZATION_ID_ASC";
    OrganizationMembershipsOrderBy["OrganizationIdDesc"] = "ORGANIZATION_ID_DESC";
    OrganizationMembershipsOrderBy["PrimaryKeyAsc"] = "PRIMARY_KEY_ASC";
    OrganizationMembershipsOrderBy["PrimaryKeyDesc"] = "PRIMARY_KEY_DESC";
    OrganizationMembershipsOrderBy["UserIdAsc"] = "USER_ID_ASC";
    OrganizationMembershipsOrderBy["UserIdDesc"] = "USER_ID_DESC";
})(OrganizationMembershipsOrderBy || (OrganizationMembershipsOrderBy = {}));
/** Methods to use when ordering `Organization`. */
export var OrganizationsOrderBy;
(function (OrganizationsOrderBy) {
    OrganizationsOrderBy["CreatedByAsc"] = "CREATED_BY_ASC";
    OrganizationsOrderBy["CreatedByDesc"] = "CREATED_BY_DESC";
    OrganizationsOrderBy["IdAsc"] = "ID_ASC";
    OrganizationsOrderBy["IdDesc"] = "ID_DESC";
    OrganizationsOrderBy["Natural"] = "NATURAL";
    OrganizationsOrderBy["PrimaryKeyAsc"] = "PRIMARY_KEY_ASC";
    OrganizationsOrderBy["PrimaryKeyDesc"] = "PRIMARY_KEY_DESC";
    OrganizationsOrderBy["SlugAsc"] = "SLUG_ASC";
    OrganizationsOrderBy["SlugDesc"] = "SLUG_DESC";
    OrganizationsOrderBy["UpdatedByAsc"] = "UPDATED_BY_ASC";
    OrganizationsOrderBy["UpdatedByDesc"] = "UPDATED_BY_DESC";
})(OrganizationsOrderBy || (OrganizationsOrderBy = {}));
export var QuestionType;
(function (QuestionType) {
    QuestionType["Checkbox"] = "CHECKBOX";
    QuestionType["Radio"] = "RADIO";
    QuestionType["Text"] = "TEXT";
})(QuestionType || (QuestionType = {}));
/** Methods to use when ordering `Quota`. */
export var QuotasOrderBy;
(function (QuotasOrderBy) {
    QuotasOrderBy["CreatedByAsc"] = "CREATED_BY_ASC";
    QuotasOrderBy["CreatedByDesc"] = "CREATED_BY_DESC";
    QuotasOrderBy["EventIdAsc"] = "EVENT_ID_ASC";
    QuotasOrderBy["EventIdDesc"] = "EVENT_ID_DESC";
    QuotasOrderBy["IdAsc"] = "ID_ASC";
    QuotasOrderBy["IdDesc"] = "ID_DESC";
    QuotasOrderBy["Natural"] = "NATURAL";
    QuotasOrderBy["PositionAsc"] = "POSITION_ASC";
    QuotasOrderBy["PositionDesc"] = "POSITION_DESC";
    QuotasOrderBy["PrimaryKeyAsc"] = "PRIMARY_KEY_ASC";
    QuotasOrderBy["PrimaryKeyDesc"] = "PRIMARY_KEY_DESC";
    QuotasOrderBy["UpdatedByAsc"] = "UPDATED_BY_ASC";
    QuotasOrderBy["UpdatedByDesc"] = "UPDATED_BY_DESC";
})(QuotasOrderBy || (QuotasOrderBy = {}));
export var RegistrationStatus;
(function (RegistrationStatus) {
    RegistrationStatus["InOpenQuota"] = "IN_OPEN_QUOTA";
    RegistrationStatus["InQueue"] = "IN_QUEUE";
    RegistrationStatus["InQuota"] = "IN_QUOTA";
})(RegistrationStatus || (RegistrationStatus = {}));
/** Methods to use when ordering `Registration`. */
export var RegistrationsOrderBy;
(function (RegistrationsOrderBy) {
    RegistrationsOrderBy["CreatedAtAsc"] = "CREATED_AT_ASC";
    RegistrationsOrderBy["CreatedAtDesc"] = "CREATED_AT_DESC";
    RegistrationsOrderBy["CreatedByAsc"] = "CREATED_BY_ASC";
    RegistrationsOrderBy["CreatedByDesc"] = "CREATED_BY_DESC";
    RegistrationsOrderBy["EventIdAsc"] = "EVENT_ID_ASC";
    RegistrationsOrderBy["EventIdDesc"] = "EVENT_ID_DESC";
    RegistrationsOrderBy["IdAsc"] = "ID_ASC";
    RegistrationsOrderBy["IdDesc"] = "ID_DESC";
    RegistrationsOrderBy["Natural"] = "NATURAL";
    RegistrationsOrderBy["PositionAsc"] = "POSITION_ASC";
    RegistrationsOrderBy["PositionDesc"] = "POSITION_DESC";
    RegistrationsOrderBy["PrimaryKeyAsc"] = "PRIMARY_KEY_ASC";
    RegistrationsOrderBy["PrimaryKeyDesc"] = "PRIMARY_KEY_DESC";
    RegistrationsOrderBy["QuotaIdAsc"] = "QUOTA_ID_ASC";
    RegistrationsOrderBy["QuotaIdDesc"] = "QUOTA_ID_DESC";
    RegistrationsOrderBy["StatusAsc"] = "STATUS_ASC";
    RegistrationsOrderBy["StatusDesc"] = "STATUS_DESC";
    RegistrationsOrderBy["UpdatedByAsc"] = "UPDATED_BY_ASC";
    RegistrationsOrderBy["UpdatedByDesc"] = "UPDATED_BY_DESC";
})(RegistrationsOrderBy || (RegistrationsOrderBy = {}));
export var SupportedLanguages;
(function (SupportedLanguages) {
    SupportedLanguages["En"] = "EN";
    SupportedLanguages["Fi"] = "FI";
})(SupportedLanguages || (SupportedLanguages = {}));
/** Methods to use when ordering `UserAuthentication`. */
export var UserAuthenticationsOrderBy;
(function (UserAuthenticationsOrderBy) {
    UserAuthenticationsOrderBy["IdAsc"] = "ID_ASC";
    UserAuthenticationsOrderBy["IdDesc"] = "ID_DESC";
    UserAuthenticationsOrderBy["Natural"] = "NATURAL";
    UserAuthenticationsOrderBy["PrimaryKeyAsc"] = "PRIMARY_KEY_ASC";
    UserAuthenticationsOrderBy["PrimaryKeyDesc"] = "PRIMARY_KEY_DESC";
    UserAuthenticationsOrderBy["ServiceAsc"] = "SERVICE_ASC";
    UserAuthenticationsOrderBy["ServiceDesc"] = "SERVICE_DESC";
    UserAuthenticationsOrderBy["UserIdAsc"] = "USER_ID_ASC";
    UserAuthenticationsOrderBy["UserIdDesc"] = "USER_ID_DESC";
})(UserAuthenticationsOrderBy || (UserAuthenticationsOrderBy = {}));
/** Methods to use when ordering `UserEmail`. */
export var UserEmailsOrderBy;
(function (UserEmailsOrderBy) {
    UserEmailsOrderBy["IdAsc"] = "ID_ASC";
    UserEmailsOrderBy["IdDesc"] = "ID_DESC";
    UserEmailsOrderBy["IsPrimaryAsc"] = "IS_PRIMARY_ASC";
    UserEmailsOrderBy["IsPrimaryDesc"] = "IS_PRIMARY_DESC";
    UserEmailsOrderBy["Natural"] = "NATURAL";
    UserEmailsOrderBy["PrimaryKeyAsc"] = "PRIMARY_KEY_ASC";
    UserEmailsOrderBy["PrimaryKeyDesc"] = "PRIMARY_KEY_DESC";
    UserEmailsOrderBy["UserIdAsc"] = "USER_ID_ASC";
    UserEmailsOrderBy["UserIdDesc"] = "USER_ID_DESC";
})(UserEmailsOrderBy || (UserEmailsOrderBy = {}));
/** Methods to use when ordering `User`. */
export var UsersOrderBy;
(function (UsersOrderBy) {
    UsersOrderBy["IdAsc"] = "ID_ASC";
    UsersOrderBy["IdDesc"] = "ID_DESC";
    UsersOrderBy["Natural"] = "NATURAL";
    UsersOrderBy["PrimaryKeyAsc"] = "PRIMARY_KEY_ASC";
    UsersOrderBy["PrimaryKeyDesc"] = "PRIMARY_KEY_DESC";
    UsersOrderBy["UsernameAsc"] = "USERNAME_ASC";
    UsersOrderBy["UsernameDesc"] = "USERNAME_DESC";
})(UsersOrderBy || (UsersOrderBy = {}));
export const EventPage_OrganizationFragmentDoc = gql `
    fragment EventPage_Organization on Organization {
  id
  name
  slug
  color
}
    `;
export const EventPage_EventCategoryFragmentDoc = gql `
    fragment EventPage_EventCategory on EventCategory {
  id
  description
  name
  color
  ownerOrganization {
    ...EventPage_Organization
  }
  updatedAt
}
    ${EventPage_OrganizationFragmentDoc}`;
export const ListEventCategoriesFragmentDoc = gql `
    fragment ListEventCategories on EventCategory {
  ...EventPage_EventCategory
}
    ${EventPage_EventCategoryFragmentDoc}`;
export const ListEventCategories_QueryFragmentDoc = gql `
    fragment ListEventCategories_Query on Query {
  eventCategories(first: $first, offset: $offset) {
    nodes {
      id
      ...ListEventCategories
    }
    totalCount
  }
}
    ${ListEventCategoriesFragmentDoc}`;
export const SharedLayout_UserEmailFragmentDoc = gql `
    fragment SharedLayout_UserEmail on UserEmail {
  id
  email
  isVerified
  isPrimary
  createdAt
}
    `;
export const SharedLayout_UserFragmentDoc = gql `
    fragment SharedLayout_User on User {
  id
  name
  username
  avatarUrl
  isAdmin
  isVerified
  primaryEmail
  userEmails(first: 50) {
    nodes {
      ...SharedLayout_UserEmail
    }
  }
  organizationMemberships(first: 20) {
    totalCount
    nodes {
      id
      isOwner
      organization {
        id
        name
        slug
      }
    }
  }
}
    ${SharedLayout_UserEmailFragmentDoc}`;
export const SharedLayout_QueryFragmentDoc = gql `
    fragment SharedLayout_Query on Query {
  currentUser {
    ...SharedLayout_User
  }
  supportedLanguages
}
    ${SharedLayout_UserFragmentDoc}`;
export const UpdateEventCategoryPage_QueryFragmentDoc = gql `
    fragment UpdateEventCategoryPage_Query on Query {
  ...SharedLayout_Query
  eventCategory(id: $id) {
    id
    ...EventPage_EventCategory
  }
}
    ${SharedLayout_QueryFragmentDoc}
${EventPage_EventCategoryFragmentDoc}`;
export const AdminListEvents_EventFragmentDoc = gql `
    fragment AdminListEvents_Event on Event {
  id
  name
  slug
  isDraft
  isHighlighted
  registrationStartTime
  eventStartTime
  category {
    id
    name
    color
  }
  quotas(orderBy: POSITION_ASC) {
    nodes {
      id
      title
      size
      registrations {
        totalCount
      }
    }
  }
  registrations {
    totalCount
  }
}
    `;
export const AdminListEvents_QueryFragmentDoc = gql `
    fragment AdminListEvents_Query on Query {
  events(first: $first, offset: $offset, filter: $filter, orderBy: $orderBy) {
    nodes {
      ...AdminListEvents_Event
    }
    totalCount
  }
}
    ${AdminListEvents_EventFragmentDoc}`;
export const CreateEventPage_QueryFragmentDoc = gql `
    fragment CreateEventPage_Query on Query {
  ...SharedLayout_Query
  eventCategories(orderBy: NAME_ASC) {
    nodes {
      ...EventPage_EventCategory
    }
  }
}
    ${SharedLayout_QueryFragmentDoc}
${EventPage_EventCategoryFragmentDoc}`;
export const ListEventsPage_QueryFragmentDoc = gql `
    fragment ListEventsPage_Query on Query {
  ...SharedLayout_Query
  eventCategories {
    nodes {
      ...EventPage_EventCategory
    }
  }
}
    ${SharedLayout_QueryFragmentDoc}
${EventPage_EventCategoryFragmentDoc}`;
export const EventFieldsFragmentDoc = gql `
    fragment EventFields on Event {
  id
  name
  slug
  description
  location
  eventStartTime
  eventEndTime
  registrationStartTime
  registrationEndTime
  isHighlighted
  isDraft
  headerImageFile
  openQuotaSize
  signupOpen
  signupUpcoming
  signupClosed
  createdBy
  updatedBy
  createdAt
  updatedAt
}
    `;
export const EventPage_QuotaFragmentDoc = gql `
    fragment EventPage_Quota on Quota {
  id
  position
  title
  size
}
    `;
export const EventPage_QuestionFragmentDoc = gql `
    fragment EventPage_Question on EventQuestion {
  id
  position
  type
  label
  isRequired
  data
}
    `;
export const UpdateEventPage_EventFragmentDoc = gql `
    fragment UpdateEventPage_Event on Event {
  ...EventFields
  category {
    ...EventPage_EventCategory
  }
  ownerOrganization {
    ...EventPage_Organization
  }
  quotas(orderBy: POSITION_ASC) {
    nodes {
      ...EventPage_Quota
      registrations {
        totalCount
      }
    }
  }
  eventQuestions(orderBy: POSITION_ASC) {
    nodes {
      ...EventPage_Question
    }
  }
}
    ${EventFieldsFragmentDoc}
${EventPage_EventCategoryFragmentDoc}
${EventPage_OrganizationFragmentDoc}
${EventPage_QuotaFragmentDoc}
${EventPage_QuestionFragmentDoc}`;
export const UpdateEventPage_QueryFragmentDoc = gql `
    fragment UpdateEventPage_Query on Query {
  ...SharedLayout_Query
  event(id: $id) {
    ...UpdateEventPage_Event
  }
  eventCategories(orderBy: NAME_ASC) {
    nodes {
      ...EventPage_EventCategory
    }
  }
}
    ${SharedLayout_QueryFragmentDoc}
${UpdateEventPage_EventFragmentDoc}
${EventPage_EventCategoryFragmentDoc}`;
export const OrganizationPage_MembershipFragmentDoc = gql `
    fragment OrganizationPage_Membership on OrganizationMembership {
  id
  createdAt
  isOwner
  user {
    id
    username
    name
  }
}
    `;
export const OrganizationPage_OrganizationFragmentDoc = gql `
    fragment OrganizationPage_Organization on Organization {
  ...EventPage_Organization
  currentUserIsOwner
  organizationMemberships(first: 10, offset: $offset, orderBy: [MEMBER_NAME_ASC]) {
    nodes {
      ...OrganizationPage_Membership
    }
    totalCount
  }
}
    ${EventPage_OrganizationFragmentDoc}
${OrganizationPage_MembershipFragmentDoc}`;
export const OrganizationPage_QueryFragmentDoc = gql `
    fragment OrganizationPage_Query on Query {
  ...SharedLayout_Query
  organizationBySlug(slug: $slug) {
    ...OrganizationPage_Organization
  }
}
    ${SharedLayout_QueryFragmentDoc}
${OrganizationPage_OrganizationFragmentDoc}`;
export const ListEventRegistrations_RegistrationFragmentDoc = gql `
    fragment ListEventRegistrations_Registration on Registration {
  id
  fullName
  email
  answers
  isFinished
  status
  position
  createdAt
  updatedAt
  quota {
    ...EventPage_Quota
  }
}
    ${EventPage_QuotaFragmentDoc}`;
export const ListEventRegistrations_QueryFragmentDoc = gql `
    fragment ListEventRegistrations_Query on Query {
  registrations(
    filter: {eventId: {equalTo: $eventId}}
    first: $first
    offset: $offset
    orderBy: [QUOTA_ID_ASC, POSITION_ASC]
  ) {
    nodes {
      ...ListEventRegistrations_Registration
    }
    totalCount
  }
}
    ${ListEventRegistrations_RegistrationFragmentDoc}`;
export const AdminListUsers_UserFragmentDoc = gql `
    fragment AdminListUsers_User on User {
  id
  username
  name
  avatarUrl
  isAdmin
  isVerified
  createdAt
}
    `;
export const EventPage_RegistrationFragmentDoc = gql `
    fragment EventPage_Registration on Registration {
  id
  fullName
  status
  position
  createdAt
  quota {
    ...EventPage_Quota
  }
}
    ${EventPage_QuotaFragmentDoc}`;
export const EventPage_EventFragmentDoc = gql `
    fragment EventPage_Event on Event {
  ...EventFields
  category {
    ...EventPage_EventCategory
  }
  ownerOrganization {
    ...EventPage_Organization
  }
  quotas(orderBy: POSITION_ASC) {
    nodes {
      ...EventPage_Quota
    }
  }
  registrations(orderBy: POSITION_ASC) {
    nodes {
      ...EventPage_Registration
    }
  }
  eventQuestions(orderBy: POSITION_ASC) {
    nodes {
      ...EventPage_Question
    }
  }
}
    ${EventFieldsFragmentDoc}
${EventPage_EventCategoryFragmentDoc}
${EventPage_OrganizationFragmentDoc}
${EventPage_QuotaFragmentDoc}
${EventPage_RegistrationFragmentDoc}
${EventPage_QuestionFragmentDoc}`;
export const EventPage_SubscriptionFragmentDoc = gql `
    fragment EventPage_Subscription on Subscription {
  currentUser {
    ...SharedLayout_User
  }
  eventBySlug(slug: $slug) {
    ...EventPage_Event
  }
}
    ${SharedLayout_UserFragmentDoc}
${EventPage_EventFragmentDoc}`;
export const HomePage_EventFragmentDoc = gql `
    fragment HomePage_Event on Event {
  ...EventFields
  ownerOrganization {
    ...EventPage_Organization
  }
  category {
    ...EventPage_EventCategory
  }
  quotas(orderBy: POSITION_ASC) {
    nodes {
      ...EventPage_Quota
      registrations {
        totalCount
      }
    }
  }
  registrations {
    totalCount
  }
}
    ${EventFieldsFragmentDoc}
${EventPage_OrganizationFragmentDoc}
${EventPage_EventCategoryFragmentDoc}
${EventPage_QuotaFragmentDoc}`;
export const HomePageClosedEvents_QueryFragmentDoc = gql `
    fragment HomePageClosedEvents_Query on Query {
  signupClosedEvents: events(
    first: $first
    offset: $offset
    filter: {signupClosed: {equalTo: true}, name: {containsKey: $language}}
    orderBy: EVENT_END_TIME_DESC
  ) {
    nodes {
      ...HomePage_Event
    }
    totalCount
  }
}
    ${HomePage_EventFragmentDoc}`;
export const HomePage_QueryFragmentDoc = gql `
    fragment HomePage_Query on Query {
  ...SharedLayout_Query
  organizations {
    nodes {
      id
      name
    }
  }
  signupOpenEvents: events(
    filter: {signupOpen: {equalTo: true}, isDraft: {equalTo: false}, name: {containsKey: $language}}
    orderBy: [IS_HIGHLIGHTED_DESC, REGISTRATION_END_TIME_ASC]
  ) {
    nodes {
      ...HomePage_Event
    }
  }
  signupUpcomingEvents: events(
    filter: {signupUpcoming: {equalTo: true}, isDraft: {equalTo: false}, name: {containsKey: $language}}
    orderBy: [IS_HIGHLIGHTED_DESC, REGISTRATION_END_TIME_ASC]
  ) {
    nodes {
      ...HomePage_Event
    }
  }
  eventCategories {
    nodes {
      ...EventPage_EventCategory
    }
  }
}
    ${SharedLayout_QueryFragmentDoc}
${HomePage_EventFragmentDoc}
${EventPage_EventCategoryFragmentDoc}`;
export const CreateEventRegistrationPage_QueryFragmentDoc = gql `
    fragment CreateEventRegistrationPage_Query on Query {
  ...SharedLayout_Query
  eventBySlug(slug: $slug) {
    ...EventPage_Event
  }
  quota(id: $quotaId) {
    ...EventPage_Quota
  }
}
    ${SharedLayout_QueryFragmentDoc}
${EventPage_EventFragmentDoc}
${EventPage_QuotaFragmentDoc}`;
export const UpdateEventRegistrationPage_RegistrationFragmentDoc = gql `
    fragment UpdateEventRegistrationPage_Registration on Registration {
  id
  firstName
  lastName
  answers
}
    `;
export const UpdateEventRegistrationPage_QueryFragmentDoc = gql `
    fragment UpdateEventRegistrationPage_Query on Query {
  ...SharedLayout_Query
  registrationByUpdateToken(updateToken: $updateToken) {
    ...UpdateEventRegistrationPage_Registration
    quota {
      ...EventPage_Quota
    }
    event {
      ...EventPage_Event
    }
  }
}
    ${SharedLayout_QueryFragmentDoc}
${UpdateEventRegistrationPage_RegistrationFragmentDoc}
${EventPage_QuotaFragmentDoc}
${EventPage_EventFragmentDoc}`;
export const EmailsForm_UserEmailFragmentDoc = gql `
    fragment EmailsForm_UserEmail on UserEmail {
  id
  email
  isVerified
  isPrimary
  createdAt
}
    `;
export const RenderEmailTemplateDocument = gql `
    query RenderEmailTemplate($template: String!, $variables: EmailTemplateVariables!) {
  renderEmailTemplate(input: {template: $template, variables: $variables}) {
    id
    name
    html
    text
  }
}
    `;
export function useRenderEmailTemplateQuery(options) {
    return Urql.useQuery({ query: RenderEmailTemplateDocument, ...options });
}
;
export const RenderEmailTemplatesDocument = gql `
    query RenderEmailTemplates {
  renderEmailTemplates {
    templates {
      id
      name
      html
      text
    }
  }
}
    `;
export function useRenderEmailTemplatesQuery(options) {
    return Urql.useQuery({ query: RenderEmailTemplatesDocument, ...options });
}
;
export const CreateEventCategoryDocument = gql `
    mutation CreateEventCategory($input: CreateEventCategoryInput!) {
  createEventCategory(input: $input) {
    eventCategory {
      ...EventPage_EventCategory
    }
  }
}
    ${EventPage_EventCategoryFragmentDoc}`;
export function useCreateEventCategoryMutation() {
    return Urql.useMutation(CreateEventCategoryDocument);
}
;
export const DeleteEventCategoryDocument = gql `
    mutation DeleteEventCategory($id: UUID!) {
  deleteEventCategory(input: {id: $id}) {
    clientMutationId
  }
}
    `;
export function useDeleteEventCategoryMutation() {
    return Urql.useMutation(DeleteEventCategoryDocument);
}
;
export const ListEventCategoriesDocument = gql `
    query ListEventCategories($offset: Int!, $first: Int!) {
  ...ListEventCategories_Query
}
    ${ListEventCategories_QueryFragmentDoc}`;
export function useListEventCategoriesQuery(options) {
    return Urql.useQuery({ query: ListEventCategoriesDocument, ...options });
}
;
export const UpdateEventCategoryPageDocument = gql `
    query UpdateEventCategoryPage($id: UUID!) {
  ...UpdateEventCategoryPage_Query
}
    ${UpdateEventCategoryPage_QueryFragmentDoc}`;
export function useUpdateEventCategoryPageQuery(options) {
    return Urql.useQuery({ query: UpdateEventCategoryPageDocument, ...options });
}
;
export const UpdateEventCategoryDocument = gql `
    mutation UpdateEventCategory($input: UpdateEventCategoryInput!) {
  updateEventCategory(input: $input) {
    eventCategory {
      ...EventPage_EventCategory
    }
  }
}
    ${EventPage_EventCategoryFragmentDoc}`;
export function useUpdateEventCategoryMutation() {
    return Urql.useMutation(UpdateEventCategoryDocument);
}
;
export const AdminListEventsDocument = gql `
    query AdminListEvents($offset: Int!, $first: Int!, $filter: EventFilter, $orderBy: [EventsOrderBy!]) {
  ...AdminListEvents_Query
}
    ${AdminListEvents_QueryFragmentDoc}`;
export function useAdminListEventsQuery(options) {
    return Urql.useQuery({ query: AdminListEventsDocument, ...options });
}
;
export const CreateEventPageDocument = gql `
    query CreateEventPage {
  ...CreateEventPage_Query
}
    ${CreateEventPage_QueryFragmentDoc}`;
export function useCreateEventPageQuery(options) {
    return Urql.useQuery({ query: CreateEventPageDocument, ...options });
}
;
export const CreateEventDocument = gql `
    mutation CreateEvent($input: CreateEventInput!) {
  createEvent(input: $input) {
    event {
      ...EventFields
    }
  }
}
    ${EventFieldsFragmentDoc}`;
export function useCreateEventMutation() {
    return Urql.useMutation(CreateEventDocument);
}
;
export const DeleteEventDocument = gql `
    mutation DeleteEvent($id: UUID!) {
  deleteEvent(input: {id: $id}) {
    clientMutationId
  }
}
    `;
export function useDeleteEventMutation() {
    return Urql.useMutation(DeleteEventDocument);
}
;
export const ListEventsPageDocument = gql `
    query ListEventsPage {
  ...ListEventsPage_Query
}
    ${ListEventsPage_QueryFragmentDoc}`;
export function useListEventsPageQuery(options) {
    return Urql.useQuery({ query: ListEventsPageDocument, ...options });
}
;
export const TranslateTextDocument = gql `
    mutation TranslateText($from: SupportedLanguages!, $to: SupportedLanguages!, $text: String!) {
  translateText(fromLanguage: $from, toLanguage: $to, text: $text) {
    originalText
    translatedText
  }
}
    `;
export function useTranslateTextMutation() {
    return Urql.useMutation(TranslateTextDocument);
}
;
export const UpdateEventPageDocument = gql `
    query UpdateEventPage($id: UUID!) {
  ...UpdateEventPage_Query
}
    ${UpdateEventPage_QueryFragmentDoc}`;
export function useUpdateEventPageQuery(options) {
    return Urql.useQuery({ query: UpdateEventPageDocument, ...options });
}
;
export const UpdateEventDocument = gql `
    mutation UpdateEvent($input: UpdateEventInput!) {
  updateEvent(input: $input) {
    event {
      ...EventFields
    }
  }
}
    ${EventFieldsFragmentDoc}`;
export function useUpdateEventMutation() {
    return Urql.useMutation(UpdateEventDocument);
}
;
export const InviteToOrganizationDocument = gql `
    mutation InviteToOrganization($organizationId: UUID!, $email: String, $username: String) {
  inviteToOrganization(
    input: {organizationId: $organizationId, email: $email, username: $username}
  ) {
    clientMutationId
  }
}
    `;
export function useInviteToOrganizationMutation() {
    return Urql.useMutation(InviteToOrganizationDocument);
}
;
export const OrganizationBySlugDocument = gql `
    query OrganizationBySlug($slug: String!) {
  organizationBySlug(slug: $slug) {
    id
    name
    slug
  }
}
    `;
export function useOrganizationBySlugQuery(options) {
    return Urql.useQuery({ query: OrganizationBySlugDocument, ...options });
}
;
export const OrganizationPageDocument = gql `
    query OrganizationPage($slug: String!, $offset: Int = 0) {
  ...OrganizationPage_Query
}
    ${OrganizationPage_QueryFragmentDoc}`;
export function useOrganizationPageQuery(options) {
    return Urql.useQuery({ query: OrganizationPageDocument, ...options });
}
;
export const RemoveFromOrganizationDocument = gql `
    mutation RemoveFromOrganization($organizationId: UUID!, $userId: UUID!) {
  removeFromOrganization(
    input: {organizationId: $organizationId, userId: $userId}
  ) {
    clientMutationId
  }
}
    `;
export function useRemoveFromOrganizationMutation() {
    return Urql.useMutation(RemoveFromOrganizationDocument);
}
;
export const TransferOrganizationOwnershipDocument = gql `
    mutation TransferOrganizationOwnership($organizationId: UUID!, $userId: UUID!) {
  transferOrganizationOwnership(
    input: {organizationId: $organizationId, userId: $userId}
  ) {
    organization {
      id
      currentUserIsOwner
    }
  }
}
    `;
export function useTransferOrganizationOwnershipMutation() {
    return Urql.useMutation(TransferOrganizationOwnershipDocument);
}
;
export const UpdateOrganizationDocument = gql `
    mutation UpdateOrganization($input: UpdateOrganizationInput!) {
  updateOrganization(input: $input) {
    organization {
      ...EventPage_Organization
    }
  }
}
    ${EventPage_OrganizationFragmentDoc}`;
export function useUpdateOrganizationMutation() {
    return Urql.useMutation(UpdateOrganizationDocument);
}
;
export const AdminDeleteRegistrationDocument = gql `
    mutation AdminDeleteRegistration($input: AdminDeleteRegistrationInput!) {
  adminDeleteRegistration(input: $input) {
    success
  }
}
    `;
export function useAdminDeleteRegistrationMutation() {
    return Urql.useMutation(AdminDeleteRegistrationDocument);
}
;
export const AdminUpdateRegistrationDocument = gql `
    mutation AdminUpdateRegistration($input: AdminUpdateRegistrationInput!) {
  adminUpdateRegistration(input: $input) {
    updateToken
  }
}
    `;
export function useAdminUpdateRegistrationMutation() {
    return Urql.useMutation(AdminUpdateRegistrationDocument);
}
;
export const ListEventRegistrationsDocument = gql `
    query ListEventRegistrations($eventId: UUID!, $offset: Int!, $first: Int!) {
  ...ListEventRegistrations_Query
}
    ${ListEventRegistrations_QueryFragmentDoc}`;
export function useListEventRegistrationsQuery(options) {
    return Urql.useQuery({ query: ListEventRegistrationsDocument, ...options });
}
;
export const AdminDeleteUserDocument = gql `
    mutation AdminDeleteUser($id: UUID!) {
  adminDeleteUser(input: {id: $id}) {
    success
  }
}
    `;
export function useAdminDeleteUserMutation() {
    return Urql.useMutation(AdminDeleteUserDocument);
}
;
export const AdminListUsersDocument = gql `
    query AdminListUsers {
  adminListUsers {
    nodes {
      ...AdminListUsers_User
    }
  }
}
    ${AdminListUsers_UserFragmentDoc}`;
export function useAdminListUsersQuery(options) {
    return Urql.useQuery({ query: AdminListUsersDocument, ...options });
}
;
export const SetAdminStatusDocument = gql `
    mutation SetAdminStatus($input: SetAdminStatusInput!) {
  setAdminStatus(input: $input) {
    success
  }
}
    `;
export function useSetAdminStatusMutation() {
    return Urql.useMutation(SetAdminStatusDocument);
}
;
export const EventPageDocument = gql `
    subscription EventPage($slug: String!) {
  ...EventPage_Subscription
}
    ${EventPage_SubscriptionFragmentDoc}`;
export function useEventPageSubscription(options = {}, handler) {
    return Urql.useSubscription({ query: EventPageDocument, ...options }, handler);
}
;
export const EventRegistrationsDocument = gql `
    subscription EventRegistrations($eventId: UUID!, $after: Datetime!) {
  eventRegistrations(eventId: $eventId) {
    registrations(after: $after) {
      ...EventPage_Registration
      quota {
        ...EventPage_Quota
      }
    }
  }
}
    ${EventPage_RegistrationFragmentDoc}
${EventPage_QuotaFragmentDoc}`;
export function useEventRegistrationsSubscription(options = {}, handler) {
    return Urql.useSubscription({ query: EventRegistrationsDocument, ...options }, handler);
}
;
export const HomePageEventsDocument = gql `
    query HomePageEvents($offset: Int, $first: Int, $language: String) {
  ...HomePageClosedEvents_Query
}
    ${HomePageClosedEvents_QueryFragmentDoc}`;
export function useHomePageEventsQuery(options) {
    return Urql.useQuery({ query: HomePageEventsDocument, ...options });
}
;
export const HomePageDocument = gql `
    query HomePage($language: String!) {
  ...HomePage_Query
}
    ${HomePage_QueryFragmentDoc}`;
export function useHomePageQuery(options) {
    return Urql.useQuery({ query: HomePageDocument, ...options });
}
;
export const CurrentTimeDocument = gql `
    subscription CurrentTime {
  currentTime
}
    `;
export function useCurrentTimeSubscription(options = {}, handler) {
    return Urql.useSubscription({ query: CurrentTimeDocument, ...options }, handler);
}
;
export const SharedDocument = gql `
    query Shared {
  ...SharedLayout_Query
}
    ${SharedLayout_QueryFragmentDoc}`;
export function useSharedQuery(options) {
    return Urql.useQuery({ query: SharedDocument, ...options });
}
;
export const AcceptOrganizationInviteDocument = gql `
    mutation AcceptOrganizationInvite($id: UUID!, $code: String) {
  acceptInvitationToOrganization(input: {invitationId: $id, code: $code}) {
    clientMutationId
  }
}
    `;
export function useAcceptOrganizationInviteMutation() {
    return Urql.useMutation(AcceptOrganizationInviteDocument);
}
;
export const CreateOrganizationDocument = gql `
    mutation CreateOrganization($name: String!, $slug: String!, $color: String!) {
  createOrganization(input: {name: $name, slug: $slug, color: $color}) {
    organization {
      ...EventPage_Organization
    }
    query {
      organizationBySlug(slug: $slug) {
        ...EventPage_Organization
      }
    }
  }
}
    ${EventPage_OrganizationFragmentDoc}`;
export function useCreateOrganizationMutation() {
    return Urql.useMutation(CreateOrganizationDocument);
}
;
export const DeleteOrganizationDocument = gql `
    mutation DeleteOrganization($organizationId: UUID!) {
  deleteOrganization(input: {organizationId: $organizationId}) {
    clientMutationId
  }
}
    `;
export function useDeleteOrganizationMutation() {
    return Urql.useMutation(DeleteOrganizationDocument);
}
;
export const InvitationDetailDocument = gql `
    query InvitationDetail($id: UUID!, $code: String) {
  ...SharedLayout_Query
  organizationForInvitation(invitationId: $id, code: $code) {
    id
    name
    slug
  }
}
    ${SharedLayout_QueryFragmentDoc}`;
export function useInvitationDetailQuery(options) {
    return Urql.useQuery({ query: InvitationDetailDocument, ...options });
}
;
export const ClaimRegistrationTokenDocument = gql `
    mutation ClaimRegistrationToken($input: ClaimRegistrationTokenInput!) {
  claimRegistrationToken(input: $input) {
    claimRegistrationTokenOutput {
      registrationToken
      updateToken
    }
  }
}
    `;
export function useClaimRegistrationTokenMutation() {
    return Urql.useMutation(ClaimRegistrationTokenDocument);
}
;
export const CreateEventRegistrationPageDocument = gql `
    query CreateEventRegistrationPage($slug: String!, $quotaId: UUID!) {
  ...CreateEventRegistrationPage_Query
}
    ${CreateEventRegistrationPage_QueryFragmentDoc}`;
export function useCreateEventRegistrationPageQuery(options) {
    return Urql.useQuery({ query: CreateEventRegistrationPageDocument, ...options });
}
;
export const CreateEventRegistrationDocument = gql `
    mutation CreateEventRegistration($input: CreateRegistrationInput!) {
  createRegistration(input: $input) {
    registration {
      ...EventPage_Registration
      quota {
        ...EventPage_Quota
      }
      event {
        id
        slug
      }
    }
  }
}
    ${EventPage_RegistrationFragmentDoc}
${EventPage_QuotaFragmentDoc}`;
export function useCreateEventRegistrationMutation() {
    return Urql.useMutation(CreateEventRegistrationDocument);
}
;
export const DeleteEventRegistrationDocument = gql `
    mutation DeleteEventRegistration($updateToken: String!) {
  deleteRegistration(input: {updateToken: $updateToken}) {
    success
  }
}
    `;
export function useDeleteEventRegistrationMutation() {
    return Urql.useMutation(DeleteEventRegistrationDocument);
}
;
export const UpdateEventRegistrationPageDocument = gql `
    query UpdateEventRegistrationPage($updateToken: String!) {
  ...UpdateEventRegistrationPage_Query
}
    ${UpdateEventRegistrationPage_QueryFragmentDoc}`;
export function useUpdateEventRegistrationPageQuery(options) {
    return Urql.useQuery({ query: UpdateEventRegistrationPageDocument, ...options });
}
;
export const UpdateEventRegistrationDocument = gql `
    mutation UpdateEventRegistration($input: UpdateRegistrationInput!) {
  updateRegistration(input: $input) {
    registration {
      ...EventPage_Registration
      firstName
      lastName
      answers
      updatedAt
    }
  }
}
    ${EventPage_RegistrationFragmentDoc}`;
export function useUpdateEventRegistrationMutation() {
    return Urql.useMutation(UpdateEventRegistrationDocument);
}
;
export const AddEmailDocument = gql `
    mutation AddEmail($email: Email!) {
  createUserEmail(input: {userEmail: {email: $email}}) {
    user {
      id
      userEmails(first: 50) {
        nodes {
          ...EmailsForm_UserEmail
        }
      }
    }
  }
}
    ${EmailsForm_UserEmailFragmentDoc}`;
export function useAddEmailMutation() {
    return Urql.useMutation(AddEmailDocument);
}
;
export const ChangePasswordDocument = gql `
    mutation ChangePassword($oldPassword: String!, $newPassword: String!) {
  changePassword(input: {oldPassword: $oldPassword, newPassword: $newPassword}) {
    success
  }
}
    `;
export function useChangePasswordMutation() {
    return Urql.useMutation(ChangePasswordDocument);
}
;
export const ConfirmAccountDeletionDocument = gql `
    mutation ConfirmAccountDeletion($token: String!) {
  confirmAccountDeletion(input: {token: $token}) {
    success
  }
}
    `;
export function useConfirmAccountDeletionMutation() {
    return Urql.useMutation(ConfirmAccountDeletionDocument);
}
;
export const CurrentUserAuthenticationsDocument = gql `
    query CurrentUserAuthentications {
  currentUser {
    id
    authentications: userAuthenticationsList(first: 50) {
      id
      service
      identifier
      createdAt
    }
  }
}
    `;
export function useCurrentUserAuthenticationsQuery(options) {
    return Urql.useQuery({ query: CurrentUserAuthenticationsDocument, ...options });
}
;
export const CurrentUserUpdatedDocument = gql `
    subscription CurrentUserUpdated {
  currentUserUpdated {
    event
    user {
      id
      username
      name
      avatarUrl
      isAdmin
      isVerified
    }
  }
}
    `;
export function useCurrentUserUpdatedSubscription(options = {}, handler) {
    return Urql.useSubscription({ query: CurrentUserUpdatedDocument, ...options }, handler);
}
;
export const DeleteEmailDocument = gql `
    mutation DeleteEmail($emailId: UUID!) {
  deleteUserEmail(input: {id: $emailId}) {
    user {
      id
      userEmails(first: 50) {
        nodes {
          ...EmailsForm_UserEmail
        }
      }
    }
  }
}
    ${EmailsForm_UserEmailFragmentDoc}`;
export function useDeleteEmailMutation() {
    return Urql.useMutation(DeleteEmailDocument);
}
;
export const ForgotPasswordDocument = gql `
    mutation ForgotPassword($email: String!) {
  forgotPassword(input: {email: $email}) {
    clientMutationId
  }
}
    `;
export function useForgotPasswordMutation() {
    return Urql.useMutation(ForgotPasswordDocument);
}
;
export const LoginDocument = gql `
    mutation Login($username: String!, $password: String!) {
  login(input: {username: $username, password: $password}) {
    user {
      id
      username
      name
    }
  }
}
    `;
export function useLoginMutation() {
    return Urql.useMutation(LoginDocument);
}
;
export const LogoutDocument = gql `
    mutation Logout {
  logout {
    success
  }
}
    `;
export function useLogoutMutation() {
    return Urql.useMutation(LogoutDocument);
}
;
export const MakeEmailPrimaryDocument = gql `
    mutation MakeEmailPrimary($emailId: UUID!) {
  makeEmailPrimary(input: {emailId: $emailId}) {
    user {
      id
      userEmails(first: 50) {
        nodes {
          id
          isPrimary
        }
      }
    }
  }
}
    `;
export function useMakeEmailPrimaryMutation() {
    return Urql.useMutation(MakeEmailPrimaryDocument);
}
;
export const PasswordStrengthDocument = gql `
    mutation PasswordStrength($password: String!) {
  calculatePasswordStrength(password: $password) {
    score
    feedback {
      suggestions
    }
  }
}
    `;
export function usePasswordStrengthMutation() {
    return Urql.useMutation(PasswordStrengthDocument);
}
;
export const RegisterDocument = gql `
    mutation Register($username: String!, $password: String!, $email: String!, $name: String!) {
  register(
    input: {username: $username, password: $password, email: $email, name: $name}
  ) {
    user {
      id
      username
      name
    }
  }
}
    `;
export function useRegisterMutation() {
    return Urql.useMutation(RegisterDocument);
}
;
export const RequestAccountDeletionDocument = gql `
    mutation RequestAccountDeletion {
  requestAccountDeletion(input: {}) {
    success
  }
}
    `;
export function useRequestAccountDeletionMutation() {
    return Urql.useMutation(RequestAccountDeletionDocument);
}
;
export const ResendEmailVerificationDocument = gql `
    mutation ResendEmailVerification($emailId: UUID!) {
  resendEmailVerificationCode(input: {emailId: $emailId}) {
    success
  }
}
    `;
export function useResendEmailVerificationMutation() {
    return Urql.useMutation(ResendEmailVerificationDocument);
}
;
export const ResetPasswordDocument = gql `
    mutation ResetPassword($userId: UUID!, $token: String!, $password: String!) {
  resetPassword(
    input: {userId: $userId, resetToken: $token, newPassword: $password}
  ) {
    success
  }
}
    `;
export function useResetPasswordMutation() {
    return Urql.useMutation(ResetPasswordDocument);
}
;
export const SettingsPasswordDocument = gql `
    query SettingsPassword {
  currentUser {
    id
    hasPassword
    primaryEmail
  }
}
    `;
export function useSettingsPasswordQuery(options) {
    return Urql.useQuery({ query: SettingsPasswordDocument, ...options });
}
;
export const UnlinkUserAuthenticationDocument = gql `
    mutation UnlinkUserAuthentication($id: UUID!) {
  deleteUserAuthentication(input: {id: $id}) {
    user {
      id
      userAuthenticationsList(first: 50) {
        id
        identifier
        service
        createdAt
      }
    }
  }
}
    `;
export function useUnlinkUserAuthenticationMutation() {
    return Urql.useMutation(UnlinkUserAuthenticationDocument);
}
;
export const UpdateUserDocument = gql `
    mutation UpdateUser($id: UUID!, $patch: UserPatch!) {
  updateUser(input: {id: $id, patch: $patch}) {
    clientMutationId
    user {
      id
      name
      username
    }
  }
}
    `;
export function useUpdateUserMutation() {
    return Urql.useMutation(UpdateUserDocument);
}
;
export const VerifyEmailDocument = gql `
    mutation VerifyEmail($id: UUID!, $token: String!) {
  verifyEmail(input: {userEmailId: $id, token: $token}) {
    success
    query {
      currentUser {
        id
        isVerified
      }
    }
  }
}
    `;
export function useVerifyEmailMutation() {
    return Urql.useMutation(VerifyEmailDocument);
}
;
//# sourceMappingURL=index.js.map